import { ComponentType } from "react";

import { IRenderer } from "./types";

export abstract class AbstractRenderer<ComponentProps = any> implements IRenderer<ComponentProps> {
    private readonly _key: string;

    constructor(key: string) {
        this._key = key;
    }

    public get key(): string {
        return this._key;
    }

    public abstract canRender(element: HTMLElement): boolean;

    public abstract get component(): ComponentType<ComponentProps>;
}
